<app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
  <!-- Header Section -->
  <div class="row align-items-center mb-3 gx-2">
    <div class="col-9 col-md-6">
      <h5 class="mb-0 text-dark fw-bold">Add Members</h5>
    </div>
  </div>

  <hr>

  <!-- Sample Form Starts -->
  <form [formGroup]="sampleForm" (ngSubmit)="submit()">
    <div class="row g-3">

      <!-- Category Dropdown -->
      <div class="col-md-6">
        <label class="form-label fw-semibold m-0">Choose Category</label>
        <ng-select [items]="categories" bindLabel="name" bindValue="_id" formControlName="categoryId"
          placeholder="Select Category"></ng-select>
        @if (sampleForm.get('categoryId')?.invalid && sampleForm.get('categoryId')?.touched) {
        <small class="text-danger">Category is required</small>
        }
      </div>

      <!-- Sample Name -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Name</span></div>
        <input type="text" formControlName="name" class="form-control form-control-sm" placeholder="Enter Name"
          (keypress)="onlyCharacters($event)" (input)="onNameInput('name', $event)">
        @if (sampleForm.get('name')?.hasError('required') && (sampleForm.get('name')?.touched || sampleForm.get('name')?.dirty)) {
        <small class="text-danger">Name is required</small>
        }
        @if (sampleForm.get('name')?.hasError('pattern') && (sampleForm.get('name')?.touched || sampleForm.get('name')?.dirty)) {
        <small class="text-danger">Only alphabetic characters and spaces are allowed</small>
        }
      </div>

      <!-- Bar Code -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Reg Code</span></div>
        <input type="text" formControlName="regNo" class="form-control form-control-sm" placeholder="Reg Code"
          (keypress)="onlyPositiveNumbers($event)" (input)="onRegNoInput($event)">
        @if (sampleForm.get('regNo')?.hasError('required') && sampleForm.get('regNo')?.touched) {
        <small class="text-danger">Reg. Code is required</small>
        }
        @if (sampleForm.get('regNo')?.hasError('pattern') && (sampleForm.get('regNo')?.touched || sampleForm.get('regNo')?.dirty)) {
        <small class="text-danger">Reg. Code must be a positive number</small>
        }
      </div>

      <!-- Age Range -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Age Range</span></div>
        <input type="text" formControlName="ageRange" class="form-control form-control-sm" placeholder="Age Range (e.g. 25 or 20-30)"
          (keypress)="onlyAgeKey($event)" (input)="onAgeInput($event)">
        @if (sampleForm.get('ageRange')?.hasError('pattern') && (sampleForm.get('ageRange')?.touched || sampleForm.get('ageRange')?.dirty)) {
        <small class="text-danger">Age must be a positive number or range (cannot be negative)</small>
        }
      </div>

      <!-- Video Title -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Height</span></div>
        <input type="text" formControlName="height" class="form-control form-control-sm" placeholder="Height">
      </div>


         <!-- Video Title -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Place of Rescue</span></div>
        <input type="text" formControlName="findLocation" class="form-control form-control-sm" placeholder="place of rescue">
      </div>


        <!-- Category Dropdown -->
      <div class="col-md-6">
        <label class="form-label fw-semibold m-0">Ward Category</label>
        <ng-select [items]="wardCategories" bindLabel="name" bindValue="id" formControlName="isHome" (change)="filterHome()"
          placeholder="Select Category"></ng-select>
      </div>

          <!-- Category Dropdown -->
      <div class="col-md-6">
        <label class="form-label fw-semibold m-0">Gender</label>
        <ng-select [items]="genders" bindLabel="name" bindValue="id" formControlName="gender"
          placeholder="Select Category"></ng-select>
      </div>

<!-- Brought By Dropdown -->
<div class="col-md-6">
  <label class="form-label fw-semibold m-0">Brought By</label>
  <ng-select 
    [items]="broughtByOptions" 
    bindLabel="name" 
    bindValue="id" 
    formControlName="broughtBy"
    placeholder="Select Brought By">
  </ng-select>

  @if (sampleForm.get('broughtBy')?.invalid && sampleForm.get('broughtBy')?.touched) {
    <small class="text-danger">Brought By is required</small>
  }
</div>



<!-- Permanent Address -->
<div class="col-md-6">
  <div class="section-header">
    <span class="section-title">Permanent Address</span>
  </div>
  <input 
    type="text" 
    formControlName="permanentAddress" 
    class="form-control form-control-sm" 
    placeholder="Enter permanent address">
</div>
      <div class="mb-3">
          <label for="role" class="form-label small text-muted mb-1">Wards</label>
          <ng-select formControlName="wardId" placeholder="Select Wards">
              @for (ward of wardData; track ward._id) {
              <ng-option [value]="ward._id">{{ ward.name }}</ng-option>
              }
          </ng-select>
      </div>


          <!-- Video Title -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Remarks</span></div>
        <textarea rows="4" type="text" formControlName="remarks" class="form-control form-control-sm" placeholder="Height"></textarea>
      </div>

      <!-- Video Link -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Youtube Video Link</span></div>
        <input type="text" formControlName="videoLink" class="form-control form-control-sm" placeholder="Youtube Link">
      </div>


      <hr>

      <!-- Image Upload Section -->
      <div class="col-12 mb-4">
        <div class="section-header"><span class="section-title">Face Image</span></div>
        <input type="file" id="file" class="form-control form-control-sm mt-1" multiple accept="image/*"  (change)="getFileDetails($event)">

        <!-- Preview List -->
        <div class="d-flex flex-wrap justify-content-start gap-3 my-1">
          @for (file of face_image; track $index) {
          <div class="card shadow-sm" style="width: 120px; border: 1px solid #dee2e6;">
            @if (file.type.startsWith('image')) {
            <div class="position-relative" style="height: 100px;">
              <img [src]="file.url" [alt]="file.name" class="card-img-top img-fluid"
                style="height: 100%; object-fit: contain; border-bottom: 1px solid #dee2e6;">
            </div>
            } @else {
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px;">
              <i class="bi bi-file-earmark fs-1 text-muted"></i>
            </div>
            }
            <div class="card-footer bg-white border-top-0 px-2 py-2 d-flex justify-content-between align-items-center">
              <small class="text-truncate" style="max-width: 70%;" [title]="file.name">{{ file.name }}</small>
              <button type="button" class="btn btn-sm btn-outline-danger p-0 px-2" (click)="removeFile($index)"
                title="Delete" aria-label="Delete">&times;</button>
            </div>
          </div>
          }
        </div>
      </div>


       <!-- Image Upload Section -->
      <div class="col-12 mb-4">
        <div class="section-header"><span class="section-title">Person Reg Image</span></div>
        <input type="file" id="file" class="form-control form-control-sm mt-1" multiple accept="image/*"  (change)="getFileDetails1($event)">

        <!-- Preview List -->
        <div class="d-flex flex-wrap justify-content-start gap-3 my-1">
          @for (file of personreg_image; track $index) {
          <div class="card shadow-sm" style="width: 120px; border: 1px solid #dee2e6;">
            @if (file.type.startsWith('image')) {
            <div class="position-relative" style="height: 100px;">
              <img [src]="file.url" [alt]="file.name" class="card-img-top img-fluid"
                style="height: 100%; object-fit: contain; border-bottom: 1px solid #dee2e6;">
            </div>
            } @else {
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px;">
              <i class="bi bi-file-earmark fs-1 text-muted"></i>
            </div>
            }
            <div class="card-footer bg-white border-top-0 px-2 py-2 d-flex justify-content-between align-items-center">
              <small class="text-truncate" style="max-width: 70%;" [title]="file.name">{{ file.name }}</small>
              <button type="button" class="btn btn-sm btn-outline-danger p-0 px-2" (click)="removeFile($index)"
                title="Delete" aria-label="Delete">&times;</button>
            </div>
          </div>
          }
        </div>
      </div>


          <!-- Image Upload Section -->
      <div class="col-12 mb-4">
        <div class="section-header"><span class="section-title">Person Image</span></div>
        <input type="file" id="file" class="form-control form-control-sm mt-1" multiple accept="image/*"  (change)="getFileDetails2($event)">

        <!-- Preview List -->
        <div class="d-flex flex-wrap justify-content-start gap-3 my-1">
          @for (file of personphoto_image; track $index) {
          <div class="card shadow-sm" style="width: 120px; border: 1px solid #dee2e6;">
            @if (file.type.startsWith('image')) {
            <div class="position-relative" style="height: 100px;">
              <img [src]="file.url" [alt]="file.name" class="card-img-top img-fluid"
                style="height: 100%; object-fit: contain; border-bottom: 1px solid #dee2e6;">
            </div>
            } @else {
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px;">
              <i class="bi bi-file-earmark fs-1 text-muted"></i>
            </div>
            }
            <div class="card-footer bg-white border-top-0 px-2 py-2 d-flex justify-content-between align-items-center">
              <small class="text-truncate" style="max-width: 70%;" [title]="file.name">{{ file.name }}</small>
              <button type="button" class="btn btn-sm btn-outline-danger p-0 px-2" (click)="removeFile($index)"
                title="Delete" aria-label="Delete">&times;</button>
            </div>
          </div>
          }
        </div>
      </div>

      <div class="col-md-6 d-flex align-items-center">
        <input type="checkbox" formControlName="isFinder" id="isFinderCheckbox" class="mx-2">
        <label for="isFinderCheckbox" class="section-header m-0 cursor-pointer"><span class="section-title">Finder Exist?</span></label>
      </div>

      <div *ngIf="this.sampleForm.value.isFinder" class="row mt-2 g-2">
        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Name</span></div>
           <input type="text" formControlName="finderName" class="form-control form-control-sm" placeholder="Finder Name"
             (keypress)="onlyCharacters($event)" (input)="onNameInput('finderName', $event)">
           @if (sampleForm.get('finderName')?.hasError('pattern') && (sampleForm.get('finderName')?.touched || sampleForm.get('finderName')?.dirty)) {
           <small class="text-danger">Only alphabetic characters and spaces are allowed</small>
           }
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Phone</span></div>
           <input type="number" formControlName="finderPhone" class="form-control form-control-sm" placeholder="Finder Number">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Another Phone</span></div>
           <input type="number" formControlName="finderAnotherPhone" class="form-control form-control-sm" placeholder="Finder Another Phone">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Proof Type</span></div>
           <input type="text" formControlName="finderProofType" class="form-control form-control-sm" placeholder="Finder Proof Type">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Proof No</span></div>
           <input type="text" formControlName="finderProofNo" class="form-control form-control-sm" placeholder="Finder Proof No">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Finder Address</span></div>
           <textarea rows="3" formControlName="finderAddress" class="form-control form-control-sm" placeholder="Finder Address"></textarea>
        </div>
      </div>

      <hr>

      <div class="col-md-6 d-flex align-items-center">
         <input type="checkbox" formControlName="isFamily" id="isFamilyCheckbox" class="mx-2">
        <label for="isFamilyCheckbox" class="section-header m-0 cursor-pointer"><span class="section-title">Reporter / Family Exist?</span></label>
      </div>

      <div *ngIf="this.sampleForm.value.isFamily" class="row mt-2 g-2">
        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Name</span></div>
           <input type="text" formControlName="familyName" class="form-control form-control-sm" placeholder="Reporter / Family Name"
             (keypress)="onlyCharacters($event)" (input)="onNameInput('familyName', $event)">
           @if (sampleForm.get('familyName')?.hasError('pattern') && (sampleForm.get('familyName')?.touched || sampleForm.get('familyName')?.dirty)) {
           <small class="text-danger">Only alphabetic characters and spaces are allowed</small>
           }
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Phone</span></div>
           <input type="number" formControlName="familyPhone" class="form-control form-control-sm" placeholder="Reporter / Family Number">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Another Phone</span></div>
           <input type="number" formControlName="familyAnotherPhone" class="form-control form-control-sm" placeholder="Reporter / Family Another Phone">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Proof Type</span></div>
           <input type="text" formControlName="familyProofType" class="form-control form-control-sm" placeholder="Reporter / Family Proof Type">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Proof No</span></div>
           <input type="text" formControlName="familyProofNo" class="form-control form-control-sm" placeholder="Reporter / Family Proof No">
        </div>

        <div class="col-md-4">
           <div class="section-header"><span class="section-title">Reporter / Family Address</span></div>
           <textarea rows="3" formControlName="familyAddress" class="form-control form-control-sm" placeholder="Reporter / Family Address"></textarea>
        </div>
      </div>



      <!-- Confirmation and Submit -->
      <div class="col-12 d-flex justify-content-between align-items-center pt-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" formControlName="confirm" />
          <label class="form-check-label small" for="confirmCheckbox">
            I confirm the details are correct
          </label>
        </div>

        <button type="submit" class="btn btn-primary btn-sm px-4 py-1">
          <i class="fas fa-paper-plane me-2"></i>Submit
        </button>
      </div>

    </div>
  </form>
</app-card>
